<template>
  <div class="md_header" :class="header_class" :style="header_class != '' && 'height: 100px;'">
    <div class="container pt-2" style="height: 85px;">
      <div class="align-horizontal h_center mt-2" style="position: relative;" >
        <div class="right" :style="header_class != '' && 'top: auto; bottom: auto'">
          <b-link @click="_back" v-show="!hide_back">
            <!--<b-img :src="require('../../assets/image/ic_back.png')" class="back_btn" />-->
            <b-img :src="require('../../assets/image/ic_close2.png')" class="dlg_close_btn" />
          </b-link>
        </div>
        <div class="title_wrapper">
          <label class="title" :style="header_class != '' && 'text-align: center; margin-top: 10px;'">{{title.primary}}</label>
        </div>
        <div class="left">
          <div class="align-horizontal" style="padding: 10px;">
            <a variant="white" class="mr-1" @click="() => {self.$emit('onLike')}" v-if="!hide_like">
              <b-img class="like_btn" :style="header_class != '' && 'width: 22px; margin-right: 10px;'" :src="is_like ? require('../../assets/image/ic_heart_on@2x.png') : require('../../assets/image/ic_heart_off@2x.png')" />
            </a>
            <a variant="white" class="" @click="() => {self.$emit('onShare')}" v-if="!hide_share">
              <b-img class="share_btn" :style="header_class != '' && 'width: 22px; margin-right: 10px;'" :src="require('../../assets/image/ic_share@2x.png')" />
            </a>
            <b-link @click="_close" v-show="!hide_close">
              <b-icon
                style="color: black"
                scale="2.5"
                icon="x"></b-icon>
            </b-link>
          </div>
        </div>
      </div>
      <div class="align-vertical center" v-if="!title.isSingle" style="height: 10px">
        <div class="align-horizontal">
          <b-img :src="require('../../assets/image/ic_address_detail@2x.png')" style="height: 1.1em;margin-bottom: 2px;" />
          <span class="address_text">{{title.address}}</span>
        </div>
      </div>
      <div class="align-vertical center align-horizontal" v-if="!title.isSingle" style="height: 10px">
      <span style="margin-top: 20px;font-size: 18px;">{{title.secondary}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MdHeaderBar",
    props:{
      title: {
        type: Object,
        default: ()=>{
          return {
            primary: '',
            isSingle: true,
            secondary: '',
            address: '',
          }
        }
      },
      hide_back: {
        type: Boolean,
        default: false
      },
      hide_close: {
        type: Boolean,
        default: true,
      },
      hide_like: {
        type: Boolean,
        default: true,
      },
      is_like: {
        type: Boolean,
        default: false,
      },
      hide_share: {
        type: Boolean,
        default: true,
      },
      isCustomBack: {
        type: Boolean,
        default: false
      },
      header_class: {
        type: String,
        default: ""
      }
    },
    data() {
        return {
          self: this,
        }
    },
    methods: {
        _back() {
          if (this.isCustomBack)
            this.$emit('back');
          else
            this.$router.back();
        },
        _close() {
            this.$router.back();
        }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/css/vars";
  .container {
    background-color: white;
  }
  .md_header {
    //height: $md_header_height;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 99;
    width: 600px;
    margin: auto;
    height: 80px;
    border-left: 1px solid rgba(0,0,0,.2);
    border-right: 1px solid rgba(0,0,0,.2);
  }
  .back_btn { display: flex; width: 15px; align-items: center; justify-content: center; margin-right: 34px }
  .left {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }
  .right {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .address_text {
    color: #0660e2;
    font-size: $fs_17;
    font-family: $korean_gd_14_r;
    margin-left: 6px;
  }
  .title {
    color: black;
    font-size: $fs_20;
    font-family: $korean_gd_15_r;
    margin: auto;
    height: 40px;
    width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  .like_btn { width: 30px; align-items: center; justify-content: center; margin-right: 15px; }
  .share_btn { width: 30px; align-items: center; justify-content: center; margin-right: 15px; }
  .dlg_close_btn {
    display: flex;
    width: 1.2em;
    height: 1.2em;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/MdHeaderBar.vue